// src/context/documentPickerCopy.js — OUR sentence for a refused upload in the shared DocumentPicker.
// ⛔ Never the server's message. Billing refusals go through RunRefusalNotice before this is asked.
export function uploadErrorCopy(t, err) {
  if (err?.code === 'DOCUMENT_INVALID_FILE_TYPE') return t('documents.picker.errors.uploadType');
  if (err?.code === 'TENANT_ADMIN_REQUIRED') return t('documents.picker.errors.notAdmin');
  if (err && typeof err.status === 'number' && err.status >= 500 && err.requestId) {
    return t('fallback.server', { ref: err.requestId });
  }
  if (!err || err.status == null) return t('fallback.network');
  return t('documents.picker.errors.generic', { code: err.code || err.status });
}
